// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3hSbh","inputDescription":"styles_inputDescription__3juWU"};